'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/users/me', null, {
            me: {method: 'GET'},
            transactions: {url: 'api/projects/transactions/new', method: 'GET'},
            logout: {url: 'logout', method: 'POST'},
        });
    }];